import type { FaireProductEntity } from "../../entity_types/product";

export const p_da8njh6txf: FaireProductEntity = {
  token: "p_da8njh6txf",
  type: "product",
  name: "Iron Tiger Spheres - 40mm (Approx. 1 Pound Bag)",
  brandToken: "b_4w78fajgal",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5926e7d45aa06f1f2f94ce3b1da31164d00f2ef93e5ca431952ec081667f2f36.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/83e61e24460c21953ff6b5602b9efcbe4c5e71e900760fc3db1e2f1d5552a6f4.jpeg",
    "https://cdn.faire.com/fastly/9ea38c1204bcc89ee9b37fa858a21411c5ad8773e43ea040fda73a8c364df506.jpeg",
    "https://cdn.faire.com/fastly/314a14578b3c3635b78835df3402603d8ec8f76d7749c7be5535eaeb60363c0f.jpeg",
    "https://cdn.faire.com/fastly/18e60b8d857e01651f7bae45944b3bf333b46e14f6584974f66f6e66b9ec4bbf.jpeg",
    "https://cdn.faire.com/fastly/a5537c4fce76a801eea1a3f1178ebffa9d3bf7a40df778b444c32a4c2d5cc694.jpeg",
    "https://cdn.faire.com/fastly/bc30c81c864dcfe68cd959f366837b063fe35636b4a33625dd2bb789d36e06e2.jpeg",
  ],
  priceDollars: 62.36,
  description:
    " Beautiful Iron Tiger Gemstone 40mm Spheres sold in 1 Pound increments.\n\n*Approximately 5-6 Spheres per Pound. \n*40mm diameter\n*Sold in  Approximate 1 Pound increments.\n*All natural gemstones\n\nThis picture is an representation of the type and quality of the gemstone you will be receiving.  As you know, there are slight variations due to the natural character of this product.",
  tags: [],
  msrpDollars: 124.71,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:25.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
